<template>
	<div>
		<router-view
			@close-modal="$emit('close-modal')"
		></router-view>
	</div>
</template>
<script>
import accountEdit from '@/components/profile/account-summary-edit';
import accountSummary from '@/components/profile/account-summary';
import { mapGetters } from 'vuex';

function closeModal() {
	this.$emit('close-modal');
}

function editAccount() {
	this.editData = true;
}

function data() {
	return {
		editData: false,
		user: {},
	};
}

export default {
	name: 'account-data',
	components: {
		accountEdit,
		accountSummary,
	},
	computed: {
		...mapGetters([
			'token',
		]),
	},
	data,
	methods: {
		closeModal,
		editAccount,
	},
};
</script>



// WEBPACK FOOTER //
// account-data.vue?2732b889